import React from "react";
import { Form } from "react-bootstrap";
import { useField } from "formik";

/** Formik + React Bootstrap field with Yup/Formik validation feedback. */
const FormField = ({
  label,
  labelIcon,
  children,
  className = "",
  groupClassName = "",
  as,
  type = "text",
  ...props
}) => {
  const [field, meta] = useField(props);
  const isInvalid = meta.touched && Boolean(meta.error);
  const isTextarea = type === "textarea" || as === "textarea";

  return (
    <Form.Group className={`mb-3 ${groupClassName}`} controlId={props.name}>
      {label && (
        <Form.Label>
          {labelIcon} {label}
        </Form.Label>
      )}

      {children ? (
        <Form.Select
          {...field}
          {...props}
          isInvalid={isInvalid}
          className={className}
        >
          {children}
        </Form.Select>
      ) : (
        <Form.Control
          {...field}
          {...props}
          type={isTextarea ? undefined : type}
          as={isTextarea ? "textarea" : as}
          isInvalid={isInvalid}
          className={className}
        />
      )}

      <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
    </Form.Group>
  );
};

export default FormField;
